import { render, staticRenderFns } from "./access-control-badge-form.vue?vue&type=template&id=54ebd66c&scoped=true&"
import script from "./access-control-badge-form.vue?vue&type=script&lang=ts&"
export * from "./access-control-badge-form.vue?vue&type=script&lang=ts&"
import style0 from "./access-control-badge-form.vue?vue&type=style&index=0&id=54ebd66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebd66c",
  null
  
)

export default component.exports